import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import querystring from 'querystring';

import { addTask } from '../../../../Actions/Dashboard/task';

import Button from '../../../Button';

class TaskInput extends React.Component {
  state = {
    string: '',
  };

  submit = (e) => {
    e.preventDefault();

    const qs = querystring.parse(window.location.search.substr(1));

    this.props.dispatch(addTask({
      string: this.state.string,
      pathway: this.props.pathway,
      bct_id: (qs.bct ? qs.bct : 0),
      b_c_t_pathway_barrier_id: (qs.barrier ? qs.barrier : 0),
    }));

    this.setState({ string: '' });
  }


  render() {
    return (
      <li className={`cb-blog_listing_item ${this.props.pathway}`}>
        <div className="wrap">
          <div className="header add">
            <form action="" onSubmit={this.submit}>
              <div className="row">
                <div className="col">
                  <input onChange={e => this.setState({ string: e.target.value })} value={this.state.string} type="text" placeholder="What needs to be done?" />
                  <span><strong>Pathway:</strong> {this.props.pathway}</span>
                  <span><strong>Barrier:</strong> {this.props.selectedbct && this.props.selectedbct.barrier.value}</span>
                  <span><strong>BCT:</strong> {this.props.selectedbct && this.props.selectedbct.bct.name}</span>               
                </div>
                <div className="col">
                  <Button label="Add task" onClick={this.submit} />
                </div>
              </div>
            </form>
          </div>
        </div>
      </li>
    );
  }
}

TaskInput.propTypes = {
  dispatch: PropTypes.func.isRequired,
  pathway: PropTypes.string.isRequired,
  selectedbct: PropTypes.object.isRequired,
};

export default connect(state => ({
  pathway: state.pathway,
  selectedbct: state.selectedbct,
}), dispatch => ({ dispatch }))(TaskInput);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Pages/Task/Input.jsx